<template>
  <div class="Navbar">
    <mu-appbar style="width: 100%;" title="郑煤机集团科技文化展示中心" color="primary">
      <!-- <div slot="left" class="leftlogo">
        <img height="46" src="../../../../static/img/logo.png">
      </div> -->

      <mu-button slot="right" flat @click="Refrash">
        <mu-icon value="autorenew" color="#ffffff"/>
      </mu-button>
    </mu-appbar>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  methods: {
    Refrash: function() {
      this.$emit('Refrash')
    }
  }
}
</script>

<style scoped>
.leftlogo{
  line-height: 1;
  margin-left: 5px;
}
.mu-appbar-title{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/BookPage/components/Navbar.vue